import { supabase } from "./supabaseClient";
import { type KetQua, thanhCong, thatBai } from "./ketQua";

export interface AppUser {
  id: string;
  email: string;
  ho_ten: string | null;
  /** QUAN_TRI = Admin · NHAN_SU = Nhân sự (QĐ-H17). */
  role: "QUAN_TRI" | "NHAN_SU";
  /** Nhãn Admin gán sẵn (QĐ-H50). null = "Tất cả". */
  nhan_mac_dinh: string | null;
}

export const laAdmin = (u: Pick<AppUser, "role"> | null | undefined) => u?.role === "QUAN_TRI";

// Trả về null nếu email đăng nhập không có trong whitelist app_user
// (RLS trả [] trong trường hợp đó — không phải lỗi, xem docs/RUNBOOK_P0.md).
// app_user chỉ trả dòng của người đang đăng nhập nhờ lọc theo auth_user_id = phiên hiện tại.
export async function layAppUserHienTai(authUserId: string): Promise<KetQua<AppUser | null>> {
  try {
    const { data, error } = await supabase
      .from("app_user")
      .select("id, email, ho_ten, role, nhan_mac_dinh")
      .eq("auth_user_id", authUserId)
      .maybeSingle();
    if (error) return thatBai(error);
    return thanhCong(data as AppUser | null);
  } catch (e) {
    return thatBai(e);
  }
}
